import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOGIN_PATH, ONBOARDING_PATH } from '@constants/routes';
import { DRIPSET_LOGO, EMSENSE_LOGO } from '@constants/images';
import { FaArrowLeftLong } from 'react-icons/fa6';

type AuthLayoutProps = {
    children: React.ReactNode;
    onBackClick: () => void;
    className?: string;
    style?: React.CSSProperties;
    hideBrandHeader?: boolean;
    hideEmsenseLogo?: boolean;
    backButtonClassName?: string;
    hideBackButton?: boolean;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({
    children,
    onBackClick,
    className,
    style,
    hideBrandHeader = false,
    hideEmsenseLogo = false,
    backButtonClassName = '',
    hideBackButton = false,
}) => {
    const { t } = useTranslation();
    const location = useLocation();

    return (
        <div className={`w-full ${(className && (className.includes('h-') || className.includes('min-h-'))) ? '' : 'min-h-screen'} flex flex-col relative ${className || 'bg-white'}`} style={style}>
            <div className="flex items-center justify-between px-4 py-3">
                {!hideBackButton && location.pathname !== ONBOARDING_PATH && (
                    <div
                        className={`flex items-center cursor-pointer absolute top-0 mt-4 text-lg text-nero font-semibold ${backButtonClassName}`}
                        onClick={onBackClick}
                    >
                        <FaArrowLeftLong className="mr-2 cursor-pointer" />
                        <span>{t('auth.back')}</span>
                    </div>
                )}
                {!hideBrandHeader && (
                    <div className="flex-grow flex justify-center">
                        <div className="logo-container">
                            <Link to={LOGIN_PATH}>
                                <img
                                    src={DRIPSET_LOGO}
                                    alt="Dripset_logo"
                                    className="object-contain w-10/12"
                                />
                            </Link>
                        </div>
                    </div>
                )}
            </div>

            {children}
            
            {/* Emsense Logo at Right Bottom Corner */}
            {!hideEmsenseLogo && <div className="absolute bottom-4 right-4 z-50">
                <img 
                    src="/public/images/emsense_logo.png" 
                    alt="Emsense Logo" 
                    className="h-10 object-contain select-none pointer-events-none" 
                />
            </div>}
        </div>
    );
};

export default AuthLayout;
